import { render, staticRenderFns } from "./DashboardFullScreen.vue?vue&type=template&id=ef2d4dc4&scoped=true"
import script from "./DashboardFullScreen.vue?vue&type=script&lang=js"
export * from "./DashboardFullScreen.vue?vue&type=script&lang=js"
import style0 from "./DashboardFullScreen.vue?vue&type=style&index=0&id=ef2d4dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d4dc4",
  null
  
)

export default component.exports